import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from "@/components/ui/resizable";
import { usePanelWidthWithMargin } from "@/hooks/usePanelWidthWithMargin";
import { useEffect } from "react";
import { useUiStore } from "@/stores/UiStore";
import ChatAutoStart from "./ChatAutoStart";

export default function ResizableChat({
  proposal_id,
  searchType,
  purpose,
  context,
  docIds,
  children,
  ...props
}) {
  const chat_panel_id = "chat-panel";
  const { width, marginRight } = usePanelWidthWithMargin(chat_panel_id);
  const wideLayout = useUiStore((state) => state.wideLayout);

  useEffect(() => {
    // This function will be called when the component is unmounted
    return () =>
      useUiStore.setState({
        wideLayout: false,
      });
  }, []);

  return (
    <ResizablePanelGroup direction="horizontal" {...props}>
      <ResizablePanel defaultSize={75} minSize={25} order={1}>
        {children}
      </ResizablePanel>
      {wideLayout && (
        <>
          <ResizableHandle className="hover:bg-primary hover:w-1.5" />

          <ResizablePanel
            minSize={25}
            maxSize={50}
            defaultSize={25}
            order={2}
            id={chat_panel_id}
          >
            <ChatAutoStart
              proposal_id={proposal_id}
              purpose={purpose}
              searchType={searchType}
              context={context}
              docIds={docIds}
              className={`fixed ${
                purpose === "proposal" ? "top-10 border-t-0 h-[calc(100vh-2.5rem)]" : "top-0"
              } right-0 rounded-none z-[2]`}
              style={{
                width: `${Math.ceil(width + marginRight)}px`,
              }}
            />
          </ResizablePanel>
        </>
      )}
    </ResizablePanelGroup>
  );
}
